<template>
  <p>
    {{ $t('You have been assigned to the following [CURRICULUM_MAP]:') }}
    <a :href="'/Atlas/Develop/View/UnitCalendar?CurriculumMapID=' + notificationData.mapId + '&YearID=' + notificationData.yearId">
      {{ notificationData.name}}
    </a>
  </p>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'courseAssignmentNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    }
  }
}
</script>
